import axios from '../request/http';
import { toFormData } from '../common/descriptions'
import { data } from 'jquery';

const order = {
    // 平台商品订单列表
    managementGoodsList(params) {
        return axios.get("/hemei-admin/order/management/goods/list", { params });
    },
    // 乡村订单列表
    VillageGoodsList(params) {
        return axios.get("/hemei-admin/order/management/villageGoods/list", { params });
    },
    // 商品分类
    categoryListAll(params) {
        return axios.get("/hemei-admin/category/listAll", { params });
    },
    // 获取售后信息
    goodsAfterDetail(params) {
        return axios.get("/hemei-admin/order/management/goods/after-detail", { params });
    },
    // 商品详情
    managementGoodsDetail(params) {
        return axios.get("/hemei-admin/order/management/goods/detail", { params });
    },
    // 订单发货
    orderExpress(data) {
        return axios.post("/hemei-admin/order/management/order/express", toFormData(data));
    },
    // 待发货订单导出
    adminGoodsOrderExport(params) {
        return axios.get("/hemei-admin/order/management/adminGoods/orderExport", { params, responseType: 'arraybuffer' });
    },
    // 待发货订单导入
    adminGoodsExport(data) {
        return axios.post("/hemei-admin/order/management/adminGoods/export", data);
    },
    // 商家订单选择商家地址
    orderAfterUpload(data) {
        return axios.post("/hemei-admin/order/management/goods/after/upload", data);
    },
    // 商家同意拒绝售后
    orderAllowOrrefuse(data) {
        return axios.post("/hemei-admin/order/management/allowOrRefuse/after", toFormData(data));
    },
    // 商家同意拒绝退款
    orderAfteraccept(params) {
        return axios.get("/hemei-admin/order/management/goods/after-accept", { params });
    },
    // 商家售后拒收
    orderRejection(data) {
        return axios.post("/hemei-admin/order/management/goods/rejection", data);
    },
    // 商家售后关闭
    orderAfterEnd(params) {
        return axios.get("/hemei-admin/order/management/goods/afterEnd", { params });
    },
    // 售后重新提交
    orderAfterReset(params) {
        return axios.get("/hemei-admin/order/management/goods/after-reset", { params });
    },
    // 物流地址列表
    orderAddressList(params) {
        return axios.get("/hemei-admin/goods/zone/admin/addressList", { params });
    },
    // 新增编辑物流地址信息
    orderAddress(data) {
        return axios.post("/hemei-admin/goods/zone/admin/address", data);
    },
    // 商家修改快递信息
    orderupdatExpress(data) {
        return axios.post("/hemei-admin/order/management/updateExpress", data);
    },
    // 订单评价
    orderEvaluateList(params) {
        return axios.get("/hemei-admin/order/management/order/evaluateList", { params });
    },
    // 回复评价
    orderEvaluatereply(data) {
        return axios.post("/hemei-admin/order/management/order/evaluatereply", toFormData(data));
    },
    // 订单分销
    orderDistribution(params) {
        return axios.get("/hemei-admin/order/management/order/distribution", { params });
    },
    // 地址删除
    delAdminAddress(params) {
        return axios.post("/hemei-admin/goods/zone/admin/delAdminAddress", null, { params });
    },
    // 再次售后
    //   delAdminAddress(params) {
    //     return axios.post("/hemei-admin/goods/zone/admin/delAdminAddress", null, {params} );
    // },
}

export default order;


// WEBPACK FOOTER //
// ./src/api/order.js